import BrowserService from "../../utilities/browserService";

function defaultDuration() {
  return 0.2;
}

function defaultTransition(overrideDuration: number) {
  const duration =
    overrideDuration !== -1 ? overrideDuration : defaultDuration();
  return { ease: "easeOut", duration: duration };
}

export function variants(overrideDuration = -1) {
  return BrowserService.transitionsSupported()
    ? {
        open: {
          x: 0,
          transition: defaultTransition(overrideDuration),
        },
        closed: {
          x: "-100%",
          transition: defaultTransition(overrideDuration),
        },
      }
    : {
        open: {
          opacity: 1,
          transition: defaultTransition(overrideDuration),
        },
        closed: {
          opacity: 0,
          transition: defaultTransition(overrideDuration),
        },
      };
}

export function variantsReverse(overrideDuration = -1) {
  return BrowserService.transitionsSupported()
    ? {
        open: {
          x: 0,
          transition: defaultTransition(overrideDuration),
        },
        closed: {
          x: "100%",
          transition: defaultTransition(overrideDuration),
        },
      }
    : {
        open: {
          opacity: 1,
          transition: defaultTransition(overrideDuration),
        },
        closed: {
          opacity: 0,
          transition: defaultTransition(overrideDuration),
        },
      };
}
